@if (expandSideNav()) {
  <div class="side-nav side-border-nav">
    <mat-nav-list>
      <div class="mat-nav-list-container">
        <div class="company-logo">
          <img class="bloom-size" src="{{ RESOURCE_SERVER_URL }}/assets/images/header/DXC_Logo_purple.svg" alt="Logo Image" />
          <span class="fill-remaining-space"></span>
          <img class="mobile-close-btn" src="{{ RESOURCE_SERVER_URL + '/assets/images/common_icons/Close.svg' }}" (click)="closeMenu.emit()" alt="Close" />
        </div>
        <div class="sidenav-profile">
          <div class="profile-icon">
            <img src="{{ RESOURCE_SERVER_URL + '/assets/images/header/Profile_top.svg' }}" alt="Profile Image" />
          </div>
          <div class="user-profile">
            <div class="user-name">
              <label>{{ getUserName() }}</label>
            </div>
            <div class="user-id">
              <label>{{ profileName() }}</label>
            </div>
          </div>
        </div>
        @if ('button' == menuType) {
          <div class="sidenav-menu">
            @for (item of listMenu(); track item) {
              @if (item.inquire) {
                <div>
                  <a mat-list-item (click)="onClick(item)" [class.active]="item.isSelected" [routerLink]="item.path" routerLinkActive="list-item-active">
                    <img src="{{ item.isSelected ? item.iconSelected : item.icon }}" />
                    <span>{{ item.name | translate }}</span>
                  </a>
                </div>
              }
            }
          </div>
        }
      </div>
    </mat-nav-list>
  </div>
} @else {
  <div class="minimized-sidenav">
    <mat-nav-list>
      <div class="minimize-logo">
        <div class="minimize-company-logo">
          <img class="bloom-size" src="{{ RESOURCE_SERVER_URL }}/assets/images/header/DXC_Logo_purple.svg" alt="Logo Image" />
        </div>
        <div class="mini-sidenav-profile">
          <div class="mini-profile-icon">
            <img src="{{ RESOURCE_SERVER_URL + '/assets/images/header/Profile_top.svg' }}" alt="Profile Image" />
          </div>
        </div>
        @if ('button' == menuType) {
          <div class="mini-sidenav-menu">
            @for (item of listMenu(); track item) {
              <div>
                <a mat-list-item (click)="onClick(item)" [class.active]="item.isSelected" [routerLink]="item.path" routerLinkActive="list-item-active">
                  <img src="{{ item.isSelected ? item.iconSelected : item.icon }}" />
                </a>
              </div>
            }
          </div>
        }
      </div>
    </mat-nav-list>
  </div>
}
